import { fieldConfig } from "@autoform/zod";
import * as z from "zod";
import { COMPONENT_VERSIONS, DEVICE_TYPES, LANGUAGES, LEGAL_DOCS, PAYMENT_METHODS } from "../common/enums";

export const partnerShape = {
	languages: z
		.array(z.enum(LANGUAGES))
		.default([])
		.check(
			fieldConfig({
				fieldType: "multiselect",
				description: "The supported languages. Select first the one that will be used as default.",
			}),
		)
		.describe("Languages"),
	supportedDeviceTypes: z
		.array(z.enum(DEVICE_TYPES))
		.default(["smartphone"])
		.check(fieldConfig({ fieldType: "multiselect" }))
		.describe("Supported Device Types"),
	componentVersion: z
		.enum(COMPONENT_VERSIONS)
		.default("3")
		.check(
			fieldConfig({
				fieldType: "singleselect",
				description: "The version of the platform components used. Make sure it matches with selected gradeType",
			}),
		)
		.describe("Component Version"),
	assessmentExpiryDays: z.number().default(0).describe("Assessment Expiry Days"),
	paymentMethods: z
		.array(z.enum(PAYMENT_METHODS))
		.default([])
		.check(
			fieldConfig({
				fieldType: "multiselect",
				description: "The supported payment methods",
			}),
		)
		.describe("Payment Methods"),
	legalDocs: z
		.array(z.enum(LEGAL_DOCS))
		.default(["privacy"])
		.check(fieldConfig({ fieldType: "multiselect" }))
		.describe("Legal Documents"),
	programName: z.string().optional().describe("Program Name"),
};

export const partnerSchema = z.object(partnerShape);

export type PartnerConfig = z.infer<typeof partnerSchema>;
